// extracted by mini-css-extract-plugin
export default {"cls1":"CitationModal-cls1__Ep","cls2":"CitationModal-cls2__R_ CitationModal-cls1__Ep"};